import { useContext, useEffect } from "react";
import { Loader } from "shared/components/Loader";
import { DEFAULT_TIMEOUT, PrintAllContext } from "../providers/PrintProvider";
import { Button, ButtonVariant, Show } from "shared/components";
import { Card } from "shared/components/Card";

export const PrintingLoading = () => {
  const {
    documentPrintingState,
    documents,
    printVerificationsState,
    setTimedOut,
    timedOut
  } = useContext(PrintAllContext);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setTimedOut(true);
    }, DEFAULT_TIMEOUT);

    return () => {
      clearTimeout(timeout);
    };
  }, []);

  if (!documentPrintingState?.length) return null;

  const uniqueDocumentKeys = new Set(
    Object.keys(documents).map((el) => el.split("-")[1])
  );

  return (
    <div className="min-h-64 no-print">
      <div className=" flex flex-col items-center">
        <Loader />
      </div>

      <p className="text-base text-content-500 text-center mt-4">
        Printing your documents. This may take a few moments. Please do not
        refresh the page.
      </p>

      <p className="text-lg text-content-500 font-medium mt-4">
        Rendered reports:{" "}
        {Object.keys(printVerificationsState).reduce((acc, curr) => {
          return printVerificationsState[curr] ? acc + 1 : acc;
        }, 0)}{" "}
        of {Object.keys(printVerificationsState).length}
      </p>

      <p className="text-lg text-content-500 font-medium mt-4">
        Total attachments: {Array.from(uniqueDocumentKeys).length}
      </p>

      {Array.from(uniqueDocumentKeys).map((key, idx) => (
        <p key={key} className="text-sm text-content-300 font-medium">
          Attachment {idx + 1}: page{" "}
          {
            Object.entries(documents).filter(
              ([el, _v]) => el.includes(key) && _v
            ).length
          }{" "}
          of{" "}
          {Object.entries(documents).filter(([el]) => el.includes(key)).length}
        </p>
      ))}

      <Show if={timedOut}>
        <Card className="animate-appear bg-warning-50 p-6 mt-4">
          <p className="text-base text-waring-800 mb-2">
            Hm... This takes longed than expected. Try manually printing the
            application
          </p>
          <Button
            variant={ButtonVariant.PRIMARY}
            onClick={() => {
              window.print();
            }}
          >
            Print manually
          </Button>
        </Card>
      </Show>
    </div>
  );
};
